enum ABLY_CHANNELS {
  NEW_MESSAGE = "new_message",
}

export default ABLY_CHANNELS;
